import gql from 'graphql-tag'

import { AuthLoginMutation } from '../../../types/api'

export default {
  mutation: gql`
    mutation AuthLogin($email: String!, $password: String!) {
      rdvLogin(email: $email, password: $password) {
        id
        token
      }
    }
  `,
  transformer: (response: AuthLoginMutation) => {
    return response.rdvLogin
  },
}
